import { Array2d, ShapeFeature, assertBBoxArray, bboxOverlap } from '@cibo/core/src/utils/geometry'
import bbox from '@turf/bbox'
import inside from '@turf/boolean-point-in-polygon'
import intersect from '@turf/intersect'
import union from '@turf/union'
import { Feature, FeatureCollection, MultiPolygon, Point, Polygon } from 'geojson'

interface OverlapsRequest {
  featureCollection: FeatureCollection<Polygon | MultiPolygon>
  testShapes: Feature<any, { boundingBox: Array2d }>[]
}

export const findEditorOverlaps = ({ featureCollection, testShapes }: OverlapsRequest) => {
  const feature = featureCollection.features.reduce(
    (acc: ShapeFeature, item: ShapeFeature) => union(acc, item) as ShapeFeature
  )

  const featureBbox = bbox(feature)
  assertBBoxArray(featureBbox)

  const candidates: Feature[] = []

  testShapes.forEach(testShape => {
    // testShape needs geojson standard boundingBox https://geojson.org/geojson-spec.html#bounding-boxes
    // ticket: https://cibotech.atlassian.net/browse/CPD-4902
    // @ts-ignore
    const testBbox = testShape.boundingBox

    if (featureBbox && testBbox) {
      if (bboxOverlap(featureBbox, testBbox)) {
        candidates.push(testShape)
      }
    }
  })

  const overlaps: Feature[] = []

  for (let i = 0, l = candidates.length; i < l; i++) {
    const candidate = candidates[i]

    if (candidate.geometry.type === 'Point') {
      if (inside(candidate as Feature<Point>, feature)) {
        overlaps.push(candidate)
      }
    } else {
      const intersection = intersect(feature, candidate as ShapeFeature)

      if (intersection && ['Polygon', 'MultiPolygon'].includes(intersection.geometry.type)) {
        overlaps.push(intersection)
      }
    }
  }

  return overlaps
}
